"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluginTemplates = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var moment = require("moment");
var react_router_dom_1 = require("react-router-dom");
var Header_1 = require("./navigator/Header");
var portal_core_1 = require("@ferry/portal-core");
var PluginTemplates = /** @class */ (function () {
    function PluginTemplates() {
        var _this = this;
        this.renderBackButton = function (link) {
            return link ?
                (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: link, className: "no-underline", children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-back plugin", children: "Back" }) }) :
                (0, jsx_runtime_1.jsx)("a", { onClick: _this.goBack, className: "no-underline", children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-back plugin", children: "Back" }) });
        };
        this.setPageTitle = function (pageTitle) {
            document.title = pageTitle;
            window.LvDataLayer = {
                pageTitle: pageTitle
            };
        };
        this.renderHeader = function () {
            return ((0, jsx_runtime_1.jsx)(Header_1.Header, {}));
        };
        this.renderFooter = function () { return ((0, jsx_runtime_1.jsx)(portal_core_1.Footer, {})); };
    }
    PluginTemplates.prototype.renderBackLink = function (buttonName, isTop, link) {
        if (link) {
            return ((0, jsx_runtime_1.jsx)("div", { className: "".concat(isTop ? "back-link-top" : "back-link-bottom"), children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: link, children: (0, jsx_runtime_1.jsx)("button", { type: "button", role: "link", className: "btn btn-back-link", children: buttonName }) }) }));
        }
        return ((0, jsx_runtime_1.jsx)("div", { className: "".concat(isTop ? "back-link-top" : "back-link-bottom"), children: (0, jsx_runtime_1.jsx)("a", { onClick: this.goBack, children: (0, jsx_runtime_1.jsx)("button", { type: "button", role: "link", className: "btn btn-back-link", children: buttonName }) }) }));
    };
    PluginTemplates.prototype.renderBackReloadLink = function (buttonName, isTop, link) {
        return ((0, jsx_runtime_1.jsx)("div", { className: "".concat(isTop ? "back-link-top" : "back-link-bottom"), children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-back-link", onClick: this.navigateTo(link), children: buttonName }) }));
    };
    PluginTemplates.prototype.goBack = function (event) {
        event.target.href = window.history.back();
    };
    PluginTemplates.prototype.navigateTo = function (link) {
        return function () {
            window.location.href = link;
        };
    };
    PluginTemplates.convertDate = function (inputDate, format) {
        var valueAsMoment = moment(inputDate, moment.ISO_8601);
        if (valueAsMoment.isValid()) {
            return (valueAsMoment.format(format));
        }
        return null;
    };
    PluginTemplates.getOrdinal = function (num) {
        var suffixes = ["th", "st", "nd", "rd"];
        var numberEnding = num % 100;
        return num + (suffixes[(numberEnding - 20) % 10] || suffixes[numberEnding] || suffixes[0]);
    };
    PluginTemplates.convertDateUTC = function (inputDate, format) {
        var valueAsMoment = moment.utc(inputDate, moment.ISO_8601);
        if (valueAsMoment.isValid()) {
            return (valueAsMoment.format(format));
        }
        return null;
    };
    return PluginTemplates;
}());
exports.PluginTemplates = PluginTemplates;
//# sourceMappingURL=PluginTemplates.js.map